import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/stories/card')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/stories/card"!</div>
}
